import { render, staticRenderFns } from "./modal-confirm.vue?vue&type=template&id=2d94da96&"
import script from "./modal-confirm.vue?vue&type=script&lang=js&"
export * from "./modal-confirm.vue?vue&type=script&lang=js&"
import style0 from "./modal-confirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d94da96')) {
      api.createRecord('2d94da96', component.options)
    } else {
      api.reload('2d94da96', component.options)
    }
    module.hot.accept("./modal-confirm.vue?vue&type=template&id=2d94da96&", function () {
      api.rerender('2d94da96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/modal/modal-confirm.vue"
export default component.exports